import { stringifyEntityRef } from '@backstage/catalog-model';
import { useTechDocsReaderPage } from '@backstage/plugin-techdocs-react';
import type { TechDocsEntityMetadata } from '@backstage/plugin-techdocs-react';

/**
 * The docs entity of the reader page, and if it still loads.
 *
 * When the reader goes from 1 doc to another, the reader context of the
 * Backstage TechDocs plugin keeps the entity of the previous doc until the next one loads. This hook
 * gives `undefined` for it, so that the page never shows the previous doc.
 */
export function useReaderEntity(): {
  entity: TechDocsEntityMetadata | undefined;
  loading: boolean;
} {
  const {
    entityRef,
    entityMetadata: { value, loading },
  } = useTechDocsReaderPage();
  const isCurrent =
    value !== undefined &&
    stringifyEntityRef(value).toLocaleLowerCase('en-US') ===
      stringifyEntityRef(entityRef).toLocaleLowerCase('en-US');

  return {
    entity: isCurrent ? value : undefined,
    loading: loading || (value !== undefined && !isCurrent),
  };
}
